import React, { useEffect, useState } from "react";
import Header from "..//../layouts/Header";
import { useHistory } from "react-router-dom";
import ListTable from "../../components/Assets/ListTable";
import DownArrow from "../../assets/icons/arrowdown.svg";
import CollapseIcon from "../../assets/icons/Colapse icon.svg";
import ExpandIcon from "../../assets/icons/ExpandSmall.svg";
import { Button, Dropdown, Menu } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import styles from "../../assets/styles/modules/Assets.module.css";
import { useSelector, useDispatch } from "react-redux";
import { assetTypes } from "../../redux/actions/action";
import location from "../../assets/icons/location1.svg";
import tool from "../../assets/icons/tool.svg";
import aperture from "../../assets/icons/aperture.svg";
import TreeListTable from "../../components/Assets/TreeListTable";
import { BiUpArrowAlt } from "react-icons/bi";
import { ROLES } from "../../utils/helpers/userRole";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
const optionarr = [false, false, false];

function Assets() {
  const history = useHistory();
  const dispatch = useDispatch();
  const roleAccess = window.localStorage.getItem("roleid");
  const [query, setQuery] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [headerToggle, setHeaderToggle] = useState("list");
  const [addNewBuutonHover, setAddNewButtonHover] = useState(false);
  const [addNewBuutonOpen, setAddNewButtonOpen] = useState(false);
  const [buttonOptionsArr, setButtonOptionsArr] = useState(optionarr);
  const [shortByArrow, setShortByArrow] = useState(false);
  const [sortedValue, setSortedValue] = useState("");
  const [expand, setExpand] = useState(false);
  const [showShortDrop, setShowShortDrop] = useState(false);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Assets-List").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  const sortByOption = [
    // { label: "Asset Name", value: "Asset Name" },
    // { label: "Internal ID", value: "Internal ID" },
    // { label: "Asset Location", value: "Asset Location" },
    // { label: "Category", value: "Category" },

    { label: t("Asset Name"), value: "Asset Name" },
    { label: t("Internal ID"), value: "Internal ID" },
    { label: t("Asset Location"), value: "Asset Location" },
    { label: t("Category"), value: "Category" },
  ];

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const closeDropdown = () => {
    setDropdownOpen(false);
  };

  const handleMenuClick = (e) => {};

  useEffect(() => {
    dispatch(assetTypes());
  }, []);

  const typesOfAssets = useSelector((data) => data.user.assetTypes);

  const buttonOptions = [
    { key: "Facility", label: "Facility", url: "/assets/newfacility" },
    { key: "Equipment", label: "Equipment", url: "/assets/equipment" },
    { key: "Part", label: "Part", url: "/assets/part" },
  ];

  const menu = (
    <Menu
      onClick={handleMenuClick}
      style={{ padding: "1rem 2.5rem", marginTop: "-2.8rem" }}
    >
      <div
        disabled
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0",
          marginBottom: "40px",
        }}
      >
        {/* Choose the type of Asset */}
        {t("Choose the type of Asset")}
        <CloseCircleOutlined onClick={() => setAddNewButtonOpen(false)} />
      </div>
      {typesOfAssets &&
        typesOfAssets.map((option, index) => (
          <Menu.Item
            key={option?.assetTypeid}
            onMouseEnter={() => {
              const arr = [...optionarr];
              arr[index] = true;
              setButtonOptionsArr(arr);
            }}
            onMouseLeave={() => {
              const arr = [...optionarr];
              arr[index] = false;
              setButtonOptionsArr(arr);
            }}
            onClick={() => {
              if (option?.assetTypeName === "Facility") {
                history.push("/asset-management/newfacility");
              } else if (option?.assetTypeName === "Equipment") {
                history.push("/asset-management/equipment");
              } else if (option?.assetTypeName === "Part") {
                history.push("/asset-management/part");
              }
            }}
            style={{
              padding: " 1.5rem 3rem",
              backgroundColor: buttonOptionsArr[index] ? "#95A7C5" : "white",
              textAlign: "start",
              boxShadow: "5px 5px 10px 0px rgba(0, 0, 0, 0.4)",
              marginBottom: "12px",
            }}
          >
            <img
              src={
                option?.assetTypeName === "Part"
                  ? tool
                  : option?.assetTypeName === "Equipment"
                  ? aperture
                  : location
              }
              alt=""
              style={{ width: "16px", height: "16px", marginRight: "15px" }}
            />
            {option?.assetTypeName}
          </Menu.Item>
        ))}
    </Menu>
  );

  return (
    <div>
      <Header
        setQuery={setQuery}
        leftComponent={
          <div
            className="flex-wrap gap-2 d-flex align-items-baseline"
            style={{ display: "flex", gap: "10%" }}
          >
            <div
              className="fw-bold "
              style={{
                fontSize: "16px",
                color: "#333333",
              }}
            >
              {/* Assets */}
              {t("Assets")}
            </div>
            <div
              className={`fw-bold dropdown col-3 ${dropdownOpen ? "open" : ""}`}
              style={{
                border: "0.5px solid #e0dada",
                borderRadius: "8px",
              }}
              onClick={toggleDropdown}
            >
              <span
                onClick={() =>
                  setHeaderToggle(headerToggle === "list" ? "list" : "tree")
                }
              >
                {headerToggle === "list" ? t("List") : t("Tree")}
              </span>
              <img
                src={DownArrow}
                className={`downarrow1 ${dropdownOpen ? "active" : ""}`}
                alt=""
                style={{ width: "12px" }}
              />
              {dropdownOpen && (
                <div
                  className="dropdown-contents py-3"
                  onClick={(e) => {
                    toggleDropdown();
                    e.stopPropagation();
                    setHeaderToggle(headerToggle === "list" ? "tree" : "list");
                  }}
                >
                  <span>{headerToggle === "list" ? t("Tree") : t("List")}</span>
                </div>
              )}
              {dropdownOpen && (
                <div className="overlay" onClick={closeDropdown} />
              )}
            </div>
          </div>
        }
      />

      <div className="parent">
        <div className="outer">
          <div className="d-flex align-items-center justify-content-between">
            {headerToggle === "list" ? (
              <div>
                <section
                  className="d-flex gap-3"
                  style={{ position: "relative" }}
                >
                  <div className="sortBy">
                    {/* Sort by */}
                    {t("Sort by")}
                  </div>
                  <BiUpArrowAlt
                    onClick={() => {
                      setShortByArrow((p) => !p);
                    }}
                    className={`${
                      shortByArrow
                        ? "down-arrow-rotate bi-paperclip cursor-pointer"
                        : "bi-paperclip cursor-pointer"
                    }`}
                  />
                  <div
                    className="datetext pointer"
                    onClick={() => setShowShortDrop((p) => !p)}
                  >
                    {sortedValue ? sortedValue : "Select"}
                  </div>

                  <div
                    className="sortDropDiv p-3 w-100"
                    style={{
                      transform: showShortDrop ? "scale(1)" : "scale(0)",
                      transitionDuration: "300ms",
                    }}
                  >
                    {sortByOption.map((item, index) => {
                      return (
                        <div
                          className={
                            sortedValue === item.label
                              ? "datetext pointer"
                              : "pointer"
                          }
                          onClick={() => {
                            setSortedValue(item.value);
                            setShowShortDrop(false);
                          }}
                        >
                          <p className="d-flex gap-">
                            {item.label}
                            {sortedValue === item.label && (
                              <p className="mb-0 ps-3">✓</p>
                            )}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                </section>
              </div>
            ) : (
              <div>
                <section
                  className="d-flex gap-4"
                  style={{ position: "relative" }}
                >
                  <div className="sortByExpand">
                    {expand ? "Expand All" : "Collapse All"}
                  </div>
                  <img
                    className={expand ? " mt-1 pointer" : " mt-1 pointer"}
                    src={expand ? ExpandIcon : CollapseIcon}
                    alt=""
                    onClick={() => {
                      setExpand((prevExpand) => !prevExpand);
                    }}
                  />
                </section>
              </div>
            )}
            {roleAccess !== ROLES.VIEWER && roleAccess !== ROLES.USER && (
              <div>
                <Dropdown
                  overlay={menu}
                  open={addNewBuutonOpen}
                  onClick={() => {
                    window.localStorage.removeItem("assetId");
                    localStorage.setItem("activeTab", "general");
                  }}
                >
                  <Button
                    className={styles.addNewButton}
                    style={{
                      backgroundColor: addNewBuutonHover && "#00246A",
                      color: "white",
                      fontWeight: 700,

                      // display: addNewBuutonOpen && "none",
                    }}
                    onClick={() => setAddNewButtonOpen(true)}
                    onMouseEnter={() => setAddNewButtonHover(true)}
                    onMouseLeave={() => setAddNewButtonHover(false)}
                  >
                    {addNewBuutonHover && (
                      <span
                        style={{
                          color: "#00246A",
                          backgroundColor: addNewBuutonHover && "white",
                          width: "18px",
                          height: "18px",
                          borderRadius: "9px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {"+"}
                      </span>
                    )}
                    {!addNewBuutonHover && (
                      <img
                        src={aperture}
                        alt=""
                        style={{
                          backgroundColor: "white",
                          borderRadius: "9px",
                          width: "18px",
                          height: "18px",
                        }}
                      />
                    )}
                    {/* Add New */}
                    {t("Add New")}
                  </Button>
                </Dropdown>
              </div>
            )}
          </div>
          {headerToggle === "list" ? (
            <ListTable
              className={styles.listTable}
              query={query}
              sortBy={`${sortedValue} ${shortByArrow ? "Desc" : "Ascnd"}`}
            />
          ) : (
            <TreeListTable
              className={styles.listTable}
              expand={expand}
              query={query}
              setQuery={setQuery}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default Assets;
